const campaignRibbon = {
  /**
   * Initialize the campaign ribbon module
   */
  init() {
    this.campaignRibbon = document.querySelector('.campaign-ribbon');
    if (this.campaignRibbon) {
      document.body.classList.add('has-ribbon');
    }
    this._updateCampaignRibbonVariableHeight();
    this.campaignRibbonCloseButton = document.querySelector('.campaign-ribbon__close-button');
    this.campaignRibbonCloseButton?.addEventListener('click', this._closeCampaignRibbon.bind(this));
    window.addEventListener('resize', this._updateCampaignRibbonVariableHeight.bind(this));
  },

  /**
   * Update campaign ribbon CSS variable (campaign-ribbon-height). This is used
   * in CSS to calculate the position of the mobile filters button.
   */
  _updateCampaignRibbonVariableHeight() {
    clearTimeout(this.resizeTimeout);
    this.resizeTimeout = setTimeout(() => {
      if (this.campaignRibbon) {
        document.documentElement.style.setProperty('--campaign-ribbon-height', `${this.campaignRibbon.offsetHeight}px`);
      }
    }, 200);
  },

  _closeCampaignRibbon() {
    this.campaignRibbon.classList.add('hidden');
  }
}

export default campaignRibbon;

